import React from "react";
import { Avatar, Card, Divider } from "antd";
import { Trophy } from "lucide-react";
import { USABLE_ICONS } from "variables/constants";

const awardees = [
  {
    name: "Saccharine Elupre",
    initials: "SE",
    position: "Marketing Manager",
    flag: "🇮🇳",
    country: "India",
    icon: "Lightbulb",
    category: "Innovation",
    achievement:
      "Developed innovative marketing campaign that increased engagement by 150%",
    color: "blue",
  },
  {
    name: "Emily Rodriguez",
    initials: "ER",
    position: "Frontend Developer",
    flag: "🇨🇴",
    country: "Colombia",
    icon: "Target",
    category: "Opportunity",
    achievement:
      "Mentored 5 junior developers and created comprehensive onboarding program",
    color: "green",
  },
  {
    name: "Ashley Palma",
    initials: "AP",
    position: "Senior Developer",
    flag: "🇵🇭",
    country: "Philippines",
    icon: "Star",
    category: "Excellence",
    achievement:
      "Delivered 3 major projects ahead of schedule with zero critical bugs",
    color: "amber",
  },
  {
    name: "James Wilson",
    initials: "JW",
    position: "HR Specialist",
    flag: "🇵🇭",
    country: "Philippines",
    icon: "Shield",
    category: "Integrity",
    achievement:
      "Handled sensitive HR matters with exemplary professionalism and fairness",
    color: "indigo",
  },
  {
    name: "Lisa Anderson",
    initials: "LA",
    position: "Financial Analyst",
    flag: "🇱🇰",
    country: "Sri Lanka",
    icon: "Heart",
    category: "Connection",
    achievement:
      "Built cross-functional relationships that improved departmental collaboration",
    color: "pink",
  },
];

const WinnersCard = ({ item }) => {
  const IconComponent =
    item?.icon && USABLE_ICONS[item.icon]
      ? USABLE_ICONS[item.icon]
      : null;

  const colorClass = item?.color;

  return (
    <Card className={`flex rounded-xl card-theme ${colorClass} w-full transition-all`}>
      <div className="flex items-center gap-3">
        <div className="relative inline-block">
          <Avatar
            size={64}
            className={`!rounded-full border-4 border-white shadow-md icon-style ${colorClass} flex items-center justify-center`}
          >
            {item.initials}
          </Avatar>

          <div className="absolute -right-1 -bottom-1 w-8 h-8 !rounded-full bg-white shadow-lg border-2 border-white flex items-center justify-center">
            <Trophy className="w-4 h-4 text-amber-500 fill-amber-500" />
          </div>
        </div>

        <div className="flex flex-col">
          <h4 className="font-semibold text-base title-text">
            {item.name}
          </h4>
          <p className="text-xs muted-text">{item.position}</p>
          <p className="text-xs muted-text">
            {item.flag} {item.country}
          </p>
        </div>

        <div
          className={`w-9 h-9 icon-style ${colorClass} shadow-lg flex items-center justify-center ml-auto`}
        >
          {IconComponent &&
            React.createElement(IconComponent, {
              className: "w-5 h-5 text-white",
            })}
        </div>
      </div>

      <Divider style={{ margin: "1rem 0", borderColor: "#e5e7eb" }} />

      <div className="flex justify-center">
        <span className={`status-indicator ${colorClass} text-xs`}>
          {item.category}
        </span>
      </div>

      <p className="text-sm title-text mt-3">Achievement</p>
      <p className="text-sm muted-text">{item.achievement}</p>

      <div className="bg-gradient-to-r from-emerald-50 to-purple-50 rounded-xl p-2 mt-3 border border-emerald-200 dark:from-emerald-900 dark:to-purple-900 dark:border-emerald-700">
        <p className="text-[13px] text-center font-medium text-emerald-700 dark:text-emerald-200">
          🎉 Congratulations! 🎉
        </p>
      </div>
    </Card>
  );
};

const AwardeeCard = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
      {awardees.map((item, index) => (
        <WinnersCard key={index} item={item} />
      ))}
    </div>
  );
};

export default AwardeeCard;